// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'
import { AddressWrapper } from './styles'

const CompanyAddress = ({ address, idRoot }) => (
  <AddressWrapper>
    <span id={`${idRoot}-street1`}>{address.street1}</span>
    <span id={`${idRoot}-street2`}>{address.street2}</span>
    <span id={`${idRoot}-city`}>{address.city}</span>
    <span id={`${idRoot}-state-zip`}>{`${address.state} ${address.zipCode}`}</span>
    <span id={`${idRoot}-country`}>{address.country}</span>
  </AddressWrapper>
)

CompanyAddress.propTypes = {
  address: object.isRequired,
  idRoot: string.isRequired,
}

export default CompanyAddress
